var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":"Time conversions","data-bs-toggle":"popover","data-bs-trigger":"hover focus","data-bs-placement":"top"}},[_vm._v(_vm._s(_vm._f("dateLocal")(_vm.date)))])}
var staticRenderFns = []

export { render, staticRenderFns }